<template>
  <div>
    <el-dialog :visible="visible" :title="title" width="40%" :modal-append-to-body="false" append-to-body
      @close="handleClose">
      <div class="basic-container">
        <div v-if="data">
          <div>
            <div class="data-container" :key="index" v-for="(item, index) in data">
              <div class="left-key" :key="index">
                {{ item.name || "" }}
              </div>
              <div class="right-content">
                <el-image v-if="item.isImage && item.value" style="width: 100px; height: 100px" :src="item.value"
                  fit="scale-down"></el-image>
                <!-- <span v-html="item.value" v-else></span> -->
                <span :class="{ 'blueText': item.name === ' ' }" v-else>{{ item.value || "" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部居中插槽 -->
      <div class="bottom-center">
        <slot v-if="slotControl.submitFooter" v-bind="data" name="submitFooter">
        </slot>
        <slot v-if="slotControl.auditFooter" v-bind="data" name="auditFooter"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WebSassMemberRightLog",
  computed: {
    title() {
      if (
        this.slotControl.submitFooter === true &&
        this.slotControl.auditFooter === false
      ) {
        return "提交审核";
      }
      if (
        this.slotControl.submitFooter === false &&
        this.slotControl.auditFooter === true
      ) {
        return "审核";
      }
    },
  },
  data() {
    return {
      slotControl: {
        submitFooter: false,
        auditFooter: false,
      },
      visible: false,
      data: {},
      id: null
    };
  },
  methods: {
    show(data) {
      console.log("data", data);
      this.data = data;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },

    /** 对话框关闭 */
    handleClose() {
      this.data = {};
      this.id = null
      this.hide();
      this.title = " ";
      this.slotControl.submitFooter = false;
      this.slotControl.auditFooter = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-container {
  padding: 20px;

  .data-container {
    display: flex;
    margin-bottom: 20px;

    .left-key {
      width: 35%;
      text-align: right;
      margin-right: 40px;
      font-weight: bold;
    }

    .right-content {
      width: 65%;
      display: flex;
      align-items: center;

      .el-image {
        margin-right: 20px;
      }
    }
  }
}

.bottom-center {
  display: flex;
  justify-content: center;
}

.blueText {
  color: #409EFF;

}
</style>
